import { SSR } from "../../common/apiUrl/ssr/ssrUrl";
import { API } from "../../common/model/objectTypes";
import { returnStatusInfo } from "../../utils/apiDescription/ssr/returnStatus";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData } from "../../utils/objectTypeConstants";
import { setDownloadStatusRequestBody } from "../../utils/ssr/apiObjects";
import { setDownloadStatusJsonRequestCurl } from "../../utils/ssr/sampleJsonRequest";

const setDownloadStatus: API = {
    name: "Set download status",
    url: `${API_BASE_URL}/${SSR.RETURN_STATUS.SET_DOWNLOAD_STATUS_URL}`,
    method: "PUT",
    headers: commonRequestHeader,
    apiInfo: returnStatusInfo.setDownloadStatus,
    requestBody: setDownloadStatusRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: setDownloadStatusJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202)
}

export const getContent = (apiName :string) => {    
    switch (apiName) {
        case 'Set Download Status':
            return setDownloadStatus;
    }
  }